/* Copyright (c) 2020 Nordcloud Oy or its affiliates. All Rights Reserved. */

import styled from "styled-components";
import { Table, theme, SVGIcon } from "@nordcloud/gnui";

export const StyledTh = styled(Table.th)`
  font-size: ${theme.fontSizes.sm} !important;
  letter-spacing: normal;
  color: ${theme.colors.darks[3]};
  font-weight: 500;
`;

export const SortWrapper = styled.span`
  position: relative;
  top: 3px;
  left: 4px;
`;

export const StyledTd = styled(Table.td)`
  vertical-align: middle;
`;

export const StyledRow = styled(Table.tr)`
  &.interactive {
    transition: opacity ${theme.transition};
    &:hover {
      opacity: 0.7;
      cursor: pointer;
    }
  }
`;

export const SVGIconDark = styled(SVGIcon)`
  margin-left: "0.25rem";
  transform: "translateY(3px)";
`;
export const SVGIconLight = styled(SVGIcon)`
  margin-left: "0.25rem";
  transform: "translateY(3px)";
  fill: ${theme.colors.lights[3]};
`;

export const StyledTable = styled(Table)`
  margin-bottom: ${({ mb }) => mb || "2rem"};
`;
